module.exports = __webpack_public_path__ + "img/finanziario.6f63a1e0.png";